import {isPC} from './methods'

function onloadRefresh(self,imgSrc) {
    let img = new Image();
    img.src = imgSrc
    if(!isPC()){
        img.onload = ()=>self.$nextTick(()=> {
            self.$children[0].bs.refresh()
            self.$children[0].maxY = self.$children[0].bs.maxScrollY
        })
    }
    img.style.width = '100vw'
    img.style.maxWidth = '1200px'
    document.querySelector('.case-img').appendChild(img);
}

export {
    onloadRefresh
}
